import React, { useContext, useState, useEffect } from 'react';
import { Modal, Form, Typography, Input } from 'antd';

import { useIntl } from 'react-intl';
import SearchLocationInput from '../components/mapsAddress';
import { StoreContext } from '../store/index';
import { addPlace } from './api';

function AddPlacesModal({ visible, onClose }) {
  const store = useContext(StoreContext);
  const {
    user: [user, setUser, setUpdateUser],
    isUserLoading: [isUserLoading, setIsUserLoading],
  } = store;
  const { formatMessage } = useIntl();
  const { Text } = Typography;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState([]);

  useEffect(() => {
    form.setFieldsValue({
      description: '',
    });
  }, []);

  const handleAddPlace = values => {
    addPlace(values, setLoading);
  };

  const onFinish = async values => {
    console.log(values);
    handleAddPlace(values, setLoading);
    onClose();
  };
  const onFinishFailed = values => {
    console.log(values);
  };

  const setMapsAddress = value => {
    setAddress(value);
    form.setFieldsValue({
      address: value.address,
    });
  };

  return (
    <Modal
      title={formatMessage({ id: 'admin.panel.add.places.button' })}
      open={visible}
      onOk={form.submit}
      okButtonProps={{ loading: loading }}
      onCancel={onClose}>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 16,
        }}
        initialValues={{
          remember: false,
          size: 'small',
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off">
        <Form.Item
          label={formatMessage({ id: 'shifts.add.modal.field.address' })}
          name="address"
          rules={[
            {
              required: true,
              message: formatMessage({
                id: 'shifts.add.modal.field.address.tooltip',
              }),
            },
          ]}>
          <SearchLocationInput setMapsAddress={setMapsAddress} />
        </Form.Item>

        {address?.address && (
          <Form.Item label="Direccion">{address?.address}</Form.Item>
        )}
        <Form.Item
          label={formatMessage({
            id: 'places.add.modal.field.name',
          })}
          name="name"
          rules={[
            {
              required: true,
              message: formatMessage({
                id: 'places.add.modal.field.name.tooltip',
              }),
            },
          ]}>
          <Input
            placeholder={formatMessage({
              id: 'places.add.modal.field.name',
            })}
          />
        </Form.Item>
        <Form.Item
          label={formatMessage({
            id: 'shifts.add.modal.field.description',
          })}
          name="description"
          rules={[
            {
              required: false,
              message: formatMessage({
                id: 'shifts.add.modal.field.description.tooltip',
              }),
            },
          ]}>
          <Input.TextArea
            placeholder={formatMessage({
              id: 'shifts.add.modal.field.description',
            })}
            autoSize={{
              minRows: 2,
              maxRows: 6,
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddPlacesModal;
